import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, TargetIcon, ZapIcon, TrophyIcon } from 'lucide-react';
import { SPECIALIZED_PACKS } from '../data/site';
const PACK_ICONS = [TargetIcon, ZapIcon, TrophyIcon];
export function Tier1Specialized() {
  return <section id="programs" className="w-full bg-ink py-16 sm:py-24 border-t border-ink-line" data-id="element-250" data-mp="usedpj5fsa8s">
      <div className="mx-auto max-w-7xl px-4 sm:px-6" data-id="element-251" data-mp="uqk1ct88dqgb">
        <div className="text-center mb-16" data-id="element-252" data-mp="pu351bqvo5s5">
          <span className="text-[11px] font-bold uppercase tracking-[0.22em] text-brand-orange" data-id="element-253" data-mp="pqxhi0xwdbyj">
            Academy Pathway
          </span>
          <h2 className="mt-3 text-3xl uppercase sm:text-4xl" data-id="element-254" data-mp="gtn3i7tp38px">Tier 1: Elite Specialized Training</h2>
          <p className="mt-4 text-white/70 max-w-2xl mx-auto" data-id="element-255" data-mp="buk71brs6atk">
            High-performance session-based programs designed for players looking to master elite techniques.
          </p>
        </div>

        {/* 2-Column Program Descriptions */}
        <div className="grid gap-8 md:grid-cols-2 mb-16" data-id="element-256" data-mp="265p7k77km74o">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="overflow-hidden rounded-3xl border border-ink-line bg-ink-card" data-id="element-257" data-mp="3hhrctwmsifp4">
            <img src="https://cdn.magicpatterns.com/patterns/generated-images/fc08029c-12d9-41cd-ab06-33ef4816e870.jpg" alt="Goalkeeper Training" className="w-full h-[200px] sm:h-[250px] object-cover object-[50%_10%] rounded-t-3xl" data-id="element-258" data-mp="3dgxpp5h694xa" />
            <div className="p-8" data-id="element-259" data-mp="92zb9xcliav2">
              <h3 className="font-display text-2xl uppercase text-white" data-id="element-260" data-mp="91xurdct8w5y">Goalkeeper Training Program</h3>
              <p className="mt-1 text-sm font-semibold text-brand-orange uppercase tracking-wide" data-id="element-261" data-mp="3remakdb8oc2c">
                Kids, Women & Men
              </p>
              <p className="mt-4 text-white/75 leading-relaxed" data-id="element-262" data-mp="nzq9i3aj9gj3">
                Focus: GK-specific conditioning, tactical situations, and individual assessment. Build the reflexes, positioning, and confidence required to command the box.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="overflow-hidden rounded-3xl border border-ink-line bg-ink-card" data-id="element-263" data-mp="xncdpcelx1up">
            <img src="https://cdn.magicpatterns.com/patterns/generated-images/77fb8120-8a37-4752-9384-0f7302e5021d.jpg" alt="Personalized Training" className="w-full h-[200px] sm:h-[250px] object-cover object-[50%_10%] rounded-t-3xl" data-id="element-264" data-mp="jocpu6yx4qzl" />
            <div className="p-8" data-id="element-265" data-mp="9yt2op46aayx">
              <h3 className="font-display text-2xl uppercase text-white" data-id="element-266" data-mp="9vos9a046izt">Personalized Training Program</h3>
              <p className="mt-1 text-sm font-semibold text-brand-orange uppercase tracking-wide" data-id="element-267" data-mp="3w586d4uzqijo">
                Elite Soccer Condition
              </p>
              <p className="mt-4 text-white/75 leading-relaxed" data-id="element-268" data-mp="3s465ykpc80g4">
                Primary Focus: Elite Soccer Condition. Tailored 1-on-1 sessions covering coordination, ball mastery, finishing drills, and physical assessment to elevate your technical ceiling and match fitness.
              </p>
            </div>
          </motion.div>
        </div>

        {/* Session Pack Pricing Card */}
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.5
      }} className="overflow-hidden rounded-3xl border border-white/10 bg-[#0b1220] shadow-2xl shadow-black/60" data-id="element-269" data-mp="2lk21yr10hlor">
          <div className="border-b border-white/10 px-6 py-8 text-center sm:px-10" data-id="element-270" data-mp="1xuhga0dh4abs">
            <h3 className="font-display text-2xl uppercase tracking-wide text-white sm:text-3xl" data-id="element-271" data-mp="22najgjtanalr">
              Elite Specialized Training
            </h3>
            <p className="mt-2 text-sm text-white/55" data-id="element-272" data-mp="1a5y9xqdzi7mc">
              Choose your session pack — Goalkeeper or Personalized 1-on-1.
            </p>
          </div>

          <ul className="divide-y divide-white/10 lg:grid lg:grid-cols-3 lg:divide-x lg:divide-y-0" data-id="element-273" data-mp="3btaw4uybsdbf">
            {SPECIALIZED_PACKS.map((plan, index) => {
            const Icon = PACK_ICONS[index];
            return <li key={plan.name} className={`relative flex flex-col p-6 sm:p-8 ${plan.featured ? 'bg-white/[0.04]' : ''}`} data-id="element-274" data-mp="3guqhyp8bunuv" data-mpi={index}>
                  {plan.badge && <span className="absolute right-6 top-6 rounded-full bg-gradient-to-r from-brand-orange to-brand-red px-3 py-1 text-[10px] font-bold uppercase tracking-[0.16em] text-white sm:right-8 sm:top-8" data-id="element-275" data-mp="3qjrzwkyfnfbh">
                      {plan.badge}
                    </span>}

                  <span className={`inline-flex h-11 w-11 items-center justify-center rounded-xl ${plan.featured ? 'bg-gradient-to-br from-brand-orange to-brand-red text-white' : 'bg-white/10 text-brand-orange'}`} data-id="element-276" data-mp="2a6jtmf9mjdbv">
                    <Icon className="h-5 w-5" aria-hidden="true" data-id="element-277" data-mp="bwug5jortznt" />
                  </span>

                  <h4 className="mt-5 font-display text-xl uppercase tracking-wide text-white" data-id="element-278" data-mp="fy69o0arn51a">
                    {plan.name}
                  </h4>

                  <p className="mt-2 flex items-end gap-1" data-id="element-279" data-mp="1wtuhr3fj7gg">
                    <span className="font-display text-5xl leading-none text-white" data-id="element-280" data-mp="6y13fthb6cop">
                      ${plan.price}
                    </span>
                  </p>

                  <ul className="mt-6 flex-grow space-y-2.5 text-sm text-white/65" data-id="element-281" data-mp="3p5h26omeani0">
                    {plan.features.map(feature => <li key={feature} className="flex gap-2.5" data-id="element-282" data-mp="1nbhued8heoa2">
                        <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand-orange" aria-hidden="true" data-id="element-283" data-mp="1rdcrt6nakhik" />
                        {feature}
                      </li>)}
                  </ul>

                  <a href={plan.ctaHref} target="_blank" rel="noreferrer" className={`mt-7 block rounded-full px-6 py-3.5 text-center text-sm font-bold uppercase tracking-wide transition-transform hover:scale-[1.02] ${plan.featured ? 'bg-gradient-to-r from-brand-orange to-brand-red text-white shadow-lg shadow-brand-red/30' : 'border border-white/20 bg-white/5 text-white hover:bg-white/10'}`} data-id="element-284" data-mp="2vdjg04b63jrs">
                    Get Started
                  </a>
                </li>;
          })}
          </ul>
        </motion.div>
      </div>
    </section>;
}